import React, { memo, HTMLProps } from 'react';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import { Element, SIZE } from '../base';

interface IProps extends HTMLProps<HTMLSpanElement> {
    icon?: string | React.ReactNode;
    isSize?: SIZE;
    color?: string;
    align?: 'left' | 'right';
    className?: string;
    renderAs?: string;
    domRef?: any;
    type?: 'bm' | 'font';
}

function getClassBmIcon(icon: string) {
    switch (icon) {
        case 'baomoi':
            return 'bg-[0_0] w-[20px] h-[20px]';
        case 'baomoi-app':
            return 'bg-[0_-3300px] w-[50px] h-[50px]';
        case 'video':
            return 'bg-[0_-773px] w-[23px] h-[23px]';
        case 'photo':
            return 'bg-[0_-723px] w-[23px] h-[23px]';
        case 'covid-1':
            return 'bg-[0_0] w-[20px] h-[20px]';
        case 'covid-2':
            return 'w-[40px] h-[40px] bg-[-50px_-3600px];';
        case 'covid-3':
            return 'w-[40px] h-[40px] bg-[0_-3650px]';
        case 'covid-4':
            return 'w-[40px] h-[40px] bg-[-50px_-3650px]';
        case 'covid-5':
            return 'w-[40px] h-[40px] bg-[-50px_-3700px]';
        case 'zalo':
            return 'w-[32px] h-[32px] bg-[0_-3450px]';
        case 'zalo-transparent':
            return 'w-[40px] h-[40px] bg-[0_-3350px]';
        case 'facebook':
            return 'w-[32px] h-[32px] bg-[-50px_-3450px]';
    }
}

function Icon({
    icon,
    isSize,
    color,
    className,
    align,
    type = 'font',
    ...rest
}: IProps) {
    const typeClass =
        type === 'bm'
            ? classNames(
                  'bm-icon',
                  'inline-block bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/bm-icon-2.0.3.png)] bg-[length:100px_4250px] align-middle'
              )
            : classNames(
                  'icon',
                  'inline-block',
                  "font-['bm-font-icon'] leading-[66%] leading-[66%]not-italic font-normal normal-case leading-none antialiased",
                  '[speak:never] [font-variant:normal]'
              );
    if (typeof icon === 'string') {
        const typeIconClass =
            type === 'bm' ? getClassBmIcon(icon) : icon ? `ic-${icon}` : '';

        return (
            <Element
                {...rest}
                renderAs="i"
                className={twMerge(typeClass, typeIconClass, className)}
            />
        );
    }

    return (
        <Element
            renderAs="i"
            className={twMerge(typeClass, className)}
            {...rest}
        >
            {icon}
        </Element>
    );
}

export default memo(Icon);
